var React = require('react');

function PlayButtonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M44.64-.003C20-.003 0 19.997 0 44.637c0 24.63 20 44.63 44.64 44.63 24.63 0 44.63-20 44.63-44.63 0-24.64-20-44.64-44.63-44.64zm0 2.92c23.02 0 41.71 18.69 41.71 41.72 0 23.02-18.69 41.71-41.71 41.71-23.03 0-41.72-18.69-41.72-41.71 0-23.03 18.69-41.72 41.72-41.72zm17.4 41.72l-26.8 17.13v-34.27l26.8 17.14z"}));
}

PlayButtonInline.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","clipRule":"evenodd","viewBox":"0 0 90 90"};

module.exports = PlayButtonInline;

PlayButtonInline.default = PlayButtonInline;
